<template>
  <div class="Header" v-if="isShowHeader">
    <div class="h-box">
      <div class="h-l">
        <div style="text-align: left;">
          <h1 style="letter-spacing: 2px;"> {{ $store.state.themeTitle }}管理平台</h1>
          <p>{{ schoolName }}</p>
        </div>

      </div>
      <div class="h-line pc">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick"
          v-if="$store.state.userInfo && $store.state.userInfo.usertype != 4">
          <el-tab-pane v-for="item in $store.state.modules" :key="item.module" :name="item.module"
            :label="item.label"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="h-r">
        <div class="logOut">
          <template v-if="!system">
            <template v-if="!isToken">
              <span class="span-style" @click="handLoginClick">请登录</span>
              <!-- <img src="../assets/image/user-noLogin.svg" class="img-style" /> -->
            </template>
            <template v-else>
              <el-dropdown v-if="organLabel" class="span-style" @command="handleCommand1" trigger="click">
                <span class="el-dropdown-link">
                  {{ organLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in organs" :key="item.id" :command="index"
                    icon="el-icon-s-unfold">{{ item.structure_text }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown class="span-style" @command="handleCommand" trigger="click">
                <span class="el-dropdown-link">
                  {{ (userInfo && userInfo.name) ? userInfo.name : '-' }}<i
                    class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-key" command="editPassword">修改密码</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-circle-close" command="logOut">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <img src="https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1743338427,2200622767&fm=26&gp=0.jpg" class="img-style" /> -->
            </template>
          </template>
          <template v-else>
            <el-dropdown class="span-style" @command="handleCommand" trigger="click">
              <span class="el-dropdown-link">
                {{ (userInfo && userInfo.name) ? userInfo.name : '-' }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-circle-close" command="outH5">退出程序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

        </div>
      </div>
    </div>
    <!-- <div class="h-line sj">
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick"
        v-if="$store.state.userInfo && $store.state.userInfo.usertype != 4">
        <el-tab-pane v-for="item in $store.state.modules" :key="item.module" :name="item.module"
          :label="item.label"></el-tab-pane>
      </el-tabs>
    </div> -->
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'Home',
  // props: ['getLogoInfo'],
  data() {
    return {
      proList: [],
      schoolName: '',
      organs: [],
      organLabel: '',
      userInfo: {},
      activeName: '',
      tabs: [],
      system: '',
      screenWidth: window.innerWidth,
      location: window.location,
    };
  },
  components: {},
  created() {
    // if (localStorage.getItem('schoolname')) {
    //   this.schoolName = localStorage.getItem('schoolname');
    // }
    if (localStorage.getItem('system')) {
      this.system = localStorage.getItem('system');
    }
    if (this.$store.state.userInfo) {
      this.userInfo = this.$store.state.userInfo;
      this.schoolName = this.userInfo.school_name
      if (this.$store.state.userInfo.weak_pwd && this.$store.state.userInfo.weak_pwd == 1) {
        this.editPassword()
      }
    }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.getOrganLabel(0)
    if (this.userInfo.defaultStructure) {
      this.getOrganLabel(this.userInfo.defaultStructure);
    }
    this.activeName = this.$store.state.currentModule;
    this.getTabs();

  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    isShowHeader() {
      return (window.innerWidth <= 1000 && this.$route.path == '/h5HomePage') || (window.innerWidth > 1000 && !this.$store.state.singlePageMenu.includes(this.$route.path))
    },
    // userInfo() {
    //   return this.$store.state.userInfo;
    // },
  },
  watch: {
    '$store.state.menu': {
      handler: function (val) {
        this.getTabs();
      },
      deep: true,
    },
    '$store.state.currentModule': {
      handler: function (val) {
        this.activeName = val;
      },
      deep: true,
    },
  },
  methods: {
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleClosecx() {
      this.$until.goHomee(this.system)
    },
    getTabs() {
      this.tabs = [];
      let menuStr = JSON.stringify(this.$store.state.menu);
      // console.log(menuStr)
      this.$store.state.defaultModules.map((item) => {
        // console.log(menuStr.indexOf(item.module))
        if (menuStr.indexOf(item.module) > -1) {
          this.tabs.push(item);
        }
      });
      if (this.tabs.length) {
        this.$store.commit('setModules', this.tabs);
        // this.$store.commit('setCurrentModule', this.tabs[0].module);
      }
    },
    handleClick(tab, event) {
      if (window.innerWidth <= 1000) {
        this.$emit("changeDrawer");
      }
      let flag = true;
      if (this.$store.state.menu) {
        this.$store.state.menu.map((item) => {
          if (item.module && item.module == tab.name) {
            if (item.childs && item.childs.length > 0 && flag) {
              this.$router.push({
                path: item.childs[0].path,
              });
              flag = false;
            } else if (!item.childs && item.path && flag) {
              this.$router.push({
                path: item.path,
              });
              flag = false;
            }
          }
        });
      }
      // this.$store.commit('setCurrentModule', tab.name);
    },
    getOrganLabel(obj) {
      let organLabel = obj.structure_text;
      if (this.userInfo && this.userInfo.structureList) {
        let strArr = this.userInfo.structureList.map((item) => {
          return item.structure_text;
        });
        this.organs = this.userInfo.structureList;
      }
      this.organLabel = organLabel;
    },
    editPassword() {
      this.$router.push({
        path: '/ChangePassword',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      } else if (com == 'editPassword') {
        this.editPassword();
      } else if (com == 'outH5') {
        this.handleClosecx();
      }
    },
    handleCommand1(com) {
      // console.log(this.organs[com])
      this.getOrganLabel(this.organs[com]);
      this.setDefaultOrgan(this.organs[com]);
    },
    async setDefaultOrgan(obj) {
      let params = { structure_id: obj.structure_ids };
      let res = await this.$api.update.setDefaultOrgan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '切换默认组织机构成功！',
        });
        this.$store.dispatch('getLogoInfo');
        // this.$emit('getLogoInfo');
        // this.dialogVisible = false;
        // this.handleQuery();
      }
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setMenu', null);
      this.$store.commit('setToken', null);
      this.$store.commit('setMenuItems', []);
      Cookies.remove('userToken');

      this.$router.push({
        path: '/login',
      });
    },
  },
};
</script>
<style lang="less" scoped>
.Header {
  // background: #3a6eaf;
  background: #4578ed;
  width: 100%;
  height: auto;
  box-shadow: 0 0 3px 1px #1b2922;
  background-image: linear-gradient(to bottom, #041ea0, #4578ed);
}

.h-box {
  width: 100%;
  height: 65px;
  box-sizing: border-box;
}

/deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  color: #fff;
}

/deep/.el-icon-circle-close:before {
  color: #555;
}

@media screen and (min-width: 1000px) {
  .Header {
    min-width: 1280px;
    height: 65px;
    background-image: none;
    background-color: #fff;
    border: 1px #ccc solid;
    box-sizing: border-box;
  }

  .pc {
    display: block;
  }

  .sj {
    display: none;
  }

  .closecx {
    display: none;
  }

  .h-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .h-l {
    padding: 0 20px 4px 40px;
    min-width: 232px;

    h1 {
      color: #3F75EA;
      font-size: 26px;
    }

    p {
      font-weight: bold;
      font-family: 黑体;
    }
  }

  .h-line {
    flex: 1;
    min-width: 830px;

    /deep/.el-tabs__item {
      height: 63px;
      line-height: 63px;
      font-size: 15px;
      letter-spacing: 1.25px;
    }
  }

  .h-r {}

  .logOut {
    //width: 144px;

    /deep/.el-dropdown {
      color: #424B56;
      padding-right: 4px;
    }
  }

  /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item {
    color: #7A8187;
    box-shadow: none;
    border: unset;
  }

  /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #333;
    background-color: #F0F1F2;
  }

  /deep/.el-tabs--border-card>.el-tabs__content {
    padding: 0 0 2px 0;
  }

  /deep/.el-tabs__nav-next {
    line-height: 64px;
  }

  /deep/.el-tabs__nav-prev {
    line-height: 64px;
  }
}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {

  .pc {
    display: none;
  }

  .sj {
    display: block;
  }

  .h-box {
    padding: 0 12px;
    height: auto;

    .h-l {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      h1 {
        margin-top: 12px;
        font-size: 20px;
        color: #fff;
      }

      p {
        display: none;
      }


    }

    .closecx {
      background: transparent;
      border: 0;
    }

    .h-r {
      width: 100%;

      .logOut {
        height: 32px;
        position: relative;
      }
    }

  }

  .h-line {

    height: 27px;
    width: 100%;

    // display: none;
    /deep/.el-tabs__item {
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      padding: 0 4px;
    }

    /deep/.el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 28px;
      color: #fff;
    }

    /deep/.el-tabs__nav-prev {
      line-height: 28px;
      color: #fff;
    }

    /deep/.el-tabs__item.is-active {
      margin-right: 8px !important;
      letter-spacing: 1;
    }

    /deep/ .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2) {
      padding-left: 8px;
    }

    /deep/.el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child {
      padding-right: 8px;
    }
  }

  /deep/.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #409eff;
  }
}


.h-r {
  text-align: right;
  position: relative;
}

.h-line {
  text-align: left;
  padding: 0 16px;
  box-sizing: border-box;

  // /deep/.el-tabs__nav {
  //   padding-top: 2px;
  // }

  /deep/.el-tabs--border-card {
    border: none;
    box-shadow: none;
    background: none;
  }

  /deep/.el-tabs__item {
    // background: #2740b3;
    color: #fff;
    // box-shadow: 0px 0px 2px 1px #1111116e;
    margin-right: 8px;
  }



  /deep/.el-tabs--border-card>.el-tabs__header {
    background-color: unset;
    border: none;
  }



}

.img-style {
  width: 54px;
  height: 54px;
  filter: drop-shadow(0px 0px 1px #ccc);
  border-radius: 29px;
  border: 2px solid #ece6e9;
}

.logOut {
  // height: 54px;
  font-size: 14px;
  color: #424B56;
  // line-height: 54px;
  // position: absolute;
  // bottom: 12px;
  // right: 0;
}

.span-style {
  vertical-align: text-bottom;
  margin-right: 12px;
  cursor: pointer;
}

.span-style:hover {
  color: #ced0dc;
  text-decoration: underline;
}

.el-dropdown {
  color: #ece6e9;
}

.el-dropdown-menu {
  width: auto;
}
</style>
